import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AdminLayoutWithDetails } from '@apps/web/components/admin/admin_layout_with_details';
import { FailureDetails } from '@apps/web/components/admin/shift_assignment_health/failure_details';
import { OrgCardList } from '@apps/web/components/admin/shift_assignment_health/org_card_list';
import {
    DATA_SOURCE_SCHEMA,
    DEFAULT_WINDOW_DAYS,
    DETAILS_SECTION_ID,
    WINDOW_DAYS_SCHEMA,
} from '@apps/web/components/admin/shift_assignment_health/shared';
import { TrendSection } from '@apps/web/components/admin/shift_assignment_health/trend_section';

export const Route = createFileRoute('/_app/admin/shift-assignment-health')({
    head: () => ({
        meta: [
            {
                title: 'Shift Assignment Failures | Phoebe Admin',
            },
        ],
    }),
    component: ShiftAssignmentHealthPage,
    validateSearch: z.object({
        failureOrganizationId: z.string().uuid().optional(),
        dataSource: DATA_SOURCE_SCHEMA.optional(),
        windowDays: z.coerce
            .number()
            .pipe(WINDOW_DAYS_SCHEMA)
            .optional()
            .catch(DEFAULT_WINDOW_DAYS),
    }),
});

function ShiftAssignmentHealthPage() {
    const { dataSource, failureOrganizationId, windowDays } = Route.useSearch();
    const effectiveWindowDays = windowDays ?? DEFAULT_WINDOW_DAYS;

    return (
        <div className="flex min-h-full flex-col">
            <TrendSection
                dataSource={dataSource}
                failureOrganizationId={failureOrganizationId}
                windowDays={effectiveWindowDays}
            />
            {/*
              Keep a full content-pane height below the trend so the admin
              outlet can scroll the graph away. The mobile header is h-14 and
              the persistent dock footer is h-9; desktop only has the footer.
            */}
            <div
                id={DETAILS_SECTION_ID}
                className="h-[calc(100svh-5.75rem)] min-h-[32rem] shrink-0 md:h-[calc(100svh-2.25rem)]"
            >
                <AdminLayoutWithDetails
                    listContent={
                        <OrgCardList
                            dataSource={dataSource}
                            failureOrganizationId={failureOrganizationId}
                            windowDays={effectiveWindowDays}
                        />
                    }
                    detailsContent={
                        <FailureDetails
                            dataSource={dataSource}
                            failureOrganizationId={failureOrganizationId}
                            windowDays={effectiveWindowDays}
                        />
                    }
                    defaultListSize={30}
                    minListSize={20}
                    defaultDetailsSize={70}
                    minDetailsSize={50}
                />
            </div>
        </div>
    );
}
